interface UploadIconProps {
  className?: string;
}

export const UploadIcon: React.FC<UploadIconProps> = ({ className = '' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.0057 13.9785V5.86964L6.41881 8.45652L5.02588 7.01383L10.0007 2.03906L14.9754 7.01383L13.5825 8.45652L10.9956 5.86964V13.9785H9.0057ZM4.03092 17.9583C3.4837 17.9583 3.01541 17.7637 2.62605 17.3743C2.23669 16.9849 2.04168 16.5163 2.04102 15.9684V12.9836H4.03092V15.9684H15.9704V12.9836H17.9603V15.9684C17.9603 16.5156 17.7656 16.9843 17.3762 17.3743C16.9869 17.7643 16.5183 17.959 15.9704 17.9583H4.03092Z"
        fill="currentColor"
      />
    </svg>
  );
};
